import { Component, EventEmitter, Output } from "@angular/core";
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core';
import { CHOSEN_LANGUAGE, DISPLAY_NAME_HEADER_KEY, EMAIL_HEADER_KEY, supportedLanguages } from '../../app.config';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent {
  iconOnlyToggled = false;
  sidebarToggled = false;
  userDisplayName: string;
  userEmail: string;

  @Output() sidebarToggle = new EventEmitter<boolean>();

  constructor(private config: NgbDropdownConfig,
              private authService: AuthService,
              private router: Router,
              public translate: TranslateService) {
    config.placement = 'bottom-right';
    this.userDisplayName = localStorage.getItem(DISPLAY_NAME_HEADER_KEY);
    this.userEmail = localStorage.getItem(EMAIL_HEADER_KEY);
  }

  toggleOffcanvas() {
    const sidebarOffcanvasSidebar = document.querySelector('.sidebar-offcanvas') as HTMLElement
    sidebarOffcanvasSidebar.classList.toggle('active');
    this.sidebarToggle.emit(true);
  }

  toggleSidebar() {
    let body = document.querySelector('body') as HTMLElement;
    if ((!body.classList.contains('sidebar-toggle-display')) && (!body.classList.contains('sidebar-absolute'))) {
      this.iconOnlyToggled = !this.iconOnlyToggled;
      if (this.iconOnlyToggled) {
        body.classList.add('sidebar-icon-only');
      } else {
        body.classList.remove('sidebar-icon-only');
      }
    } else {
      this.sidebarToggled = !this.sidebarToggled;
      if (this.sidebarToggled) {
        body.classList.add('sidebar-hidden');
      } else {
        body.classList.remove('sidebar-hidden');
      }
    }
    this.sidebarToggle.emit(this.sidebarToggled || this.iconOnlyToggled);
  }

  changeLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem(CHOSEN_LANGUAGE, lang);
  }

  logout() {
    this.authService.logout(() => this.router.navigate(['/login']))
  }

  protected readonly supportedLanguages = supportedLanguages;
}
